<template>
  <div class="l-container UsersAdd">
    <form class="h-adr">
      <p class="m-label">新規追加</p>
      <user-form :user="user" :watch="watch"></user-form>
      <btn class="u-btn u-btn--add" @click.native="postUser"><i class="fa fa-user-plus"></i>Userを新規追加</btn>
    </form>
  </div>
</template>

<script>
export default {
  computed: {
  },
  directives: {
    focus: {
      inserted (el, binding) {
        el.focus()
        // console.log(el)
        // console.log(binding)
      }
    }
  },
  data () {
    return {
      asc: '',
      desc: '',
      sortState: '',

      user: {
        user: '',
        name: '',
        email: '',
        type: '',
        office: ''
      },

      watch: {
        type: '',
        office: ''
      }
    }
  },
  watch: {
    'watch.type': function (now, old) {
      // console.log(now)
      if (now) {
        this.user.type = now.value
      } else {
        this.user.type = ''
      }
    },

    'watch.office': function (now, old) {
      // console.log(now)
      if (now) {
        this.user.office = now.value
      } else {
        this.user.office = ''
      }
    }
  },
  // beforeRouteEnter (to, from, next) {
  //   next(vm => {
  //     vm.getAdvisors()
  //   })
  // },
  methods: {
    select (selectedOption, id) {
      // console.log(selectedOption)
      // console.log(this.searchType)
    },

    // getAdvisors () {
    //   this.$store.dispatch('getAdvisors')
    // },
    //
    postUser () {
      this.$store.dispatch('postUser', {
        this: this,
        user: this.user
      })
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.table {
  margin-top: 0 !important;
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}
.th {
  cursor: pointer;
}
.select {
  padding: 0 !important;
}
.fa-user-plus {
  margin-right: 5px;
}
.u-btn {
  margin-top: 1rem;
}
button {
  margin-bottom: 13px;
}
input {
  width: 100%;
  min-width: 100px;
  height: 100%;
  padding: 0;
  outline: 0;
  border: none;
}
.clicked {
  background: #41B883;
  font-weight: bold;
  color: #fff;
}
</style>
<style lang="scss">
.UsersAdd {
  .multiselect {
    min-height: 23px;
    min-width: 100px;
  }
  .multiselect__tags {
    border: solid 1px #ccc;
    min-height: 23px;
    padding: 0px 23px 0 2px;
    border-radius: 0;
    border: none;
    margin: 1px;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 23px;
  }
  .multiselect__select {
    height: 23px;
    width: 26px;
    top: 2px;
    padding: 0;
  }
  .vdp-datepicker {
    margin-right: 2px;
    input {
      /* height: 37px; */
      border: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// UsersAdd.vue?7726082c